import { SET_FULL_EMPLOYER } from "../actions/entitiesActions";

const defaultState = {
  fullEmployer: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_FULL_EMPLOYER:
        return {
          ...state,
          fullEmployer: action.payload,
        };
  }
  return state;
};
